// extracted by mini-css-extract-plugin
export default {"product_container":"Result_product_container__wwfJt","border":"Result_border__fBs5E"};